import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Col, Row, Card } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";

// Import the hook to fetch data
import { useNews } from "@/hooks/useNews";
// Assuming a hook to get the current locale exists
// import { useLocale } from "@/hooks/useLocale";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

export const ThemeAMultiColumnCTA = ({
  customClass = "py-4",
  content,
  left_content,
  buttonLink_left,
  buttonTitle_left,
  swiperID = "lifeAtC60",
  pagePrefix = "/insights/",
  newTab = false,
  limit = 3,
  filters = null,
}) => {
  // const { locale } = useLocale();

  const posts = useNews({ filters, limit });

  if (!posts || posts.length === 0) {
    return null;
  }

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.${swiperID}.swiper-custom-paginations`,
    },
    navigation: {
      nextEl: `.${swiperID}.swiper-next`,
      prevEl: `.${swiperID}.swiper-prev`,
    },
  };

  return (
    <>
      <section className={`${styles.root} ${customClass}`}>
        <Container>
          {content ? (
            <div className="mb-5">
              {/* <SourceFlowText
                global={global}
                path={`${pathPrefix}.content`}
                type="html"
              >
                {content}
              </SourceFlowText> */}
              <span dangerouslySetInnerHTML={{ __html: content }}></span>
            </div>
          ) : (
            ""
          )}
          <Row className="m-0">
            <Col
              md={4}
              className="left-column px-4 pt-5 position-relative overflow-hidden"
            >
              <span dangerouslySetInnerHTML={{ __html: left_content }}></span>

              {/* <SourceFlowText
                global={global}
                path={`${pathPrefix}.left_content`}
                type="html"
              >
                {left_content}
              </SourceFlowText> */}
              {buttonLink_left && (
                <div className="mt-4">
                  <Link href={buttonLink_left}>
                    <a
                      className="secondaryBtn no-arrow"
                      target={newTab ? "_blank" : "_self"}
                      rel={newTab ? "noopener noreferrer" : ""}
                    >
                      {buttonTitle_left}
                    </a>
                  </Link>
                </div>
              )}
            </Col>
            <Col md={8} className="p-0 ps-md-4 position-relative">
              <Swiper {...settings}>
                {posts.map((post, index) => (
                  <SwiperSlide key={index}>
                    <Card className="border-0 h-100">
                      <Row className="h-100">
                        <Col md={4} className="p-md-0">
                          <SourceFlowImage
                            src={
                              post?.image
                                ? post.image
                                : "/site-assets/placeholders/img-placeholder.jpg"
                            }
                            size="800x"
                            alt={post?.title}
                            className="card-img rounded-0"
                          />
                        </Col>
                        <Col md={8} className="right-column-post p-5">
                          <p className="fs-5">
                            <strong>{post?.title}</strong>
                          </p>
                          {post?.short_description && (
                            <div
                              className="mt-2"
                              dangerouslySetInnerHTML={{
                                __html: post?.short_description,
                              }}
                            />
                          )}
                          <div className="mt-5">
                            <Link href={`${pagePrefix}${post.url_slug}/`}>
                              <a className="secondaryBtn no-arrow">
                                Read article
                              </a>
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div
                className={`${swiperID} swiper-custom-paginations position-absolute`}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ThemeAMultiColumnCTA;
